import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';

export interface Occupation {
    occupationCode: number;
    occupationDescription: string;
    category?: number;
}

@Injectable({
    providedIn: 'root',
})
export class OccupationsService {
    private http = inject(HttpClient);
    private controller = `occupations`;

    getOccupations() {
        return this.http.get<Occupation[]>(this.controller);
    }

    updateCategory(code: number, category: number) {
        return this.http.put<void>(`${this.controller}/${code}/category`, category);
    }
}
